export default class TwoFactorAuthService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  getTwoFactorMethods() {
    return this.$http.get(this.#serviceMfaBaseUrl('methods'));
  }

  getMFASettings() {
    return this.$http.get(this.#serviceMfaBaseUrl());
  }

  disableMFA() {
    return this.$http.delete(this.#serviceMfaBaseUrl());
  }

  enableMFA(MFAModel) {
    return this.$http.put(this.#serviceMfaBaseUrl(), MFAModel);
  }

  #serviceMfaBaseUrl(path) {
    const url = `${this.serviceBaseUri}Account/mfa/`;
    if (path) {
      return url + path;
    }
    return url;
  }
}
